module.exports = __webpack_public_path__ + "img/btn-bg-pink2.png?d9975644d161792486156247f3258aff";